import { render, staticRenderFns } from "./billList.vue?vue&type=template&id=6b5eb988&scoped=true&"
import script from "./billList.vue?vue&type=script&lang=js&"
export * from "./billList.vue?vue&type=script&lang=js&"
import style0 from "./billList.vue?vue&type=style&index=0&id=6b5eb988&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5eb988",
  null
  
)

export default component.exports